import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useHover } from "designSystem/hooks";
import { FlexRowCenter, IconButton } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC, RefObject, forwardRef } from "react";
import { CustomViewItemActionMenuProps } from "./CustomViewItemActionMenu";
import CustomViewItemEditorPopup from "./CustomViewItemEditorPopup";

const CustomViewItemActionMenuPartial: FC<CustomViewItemActionMenuProps> = observer(forwardRef((props: CustomViewItemActionMenuProps, ref: RefObject<HTMLElement>) => {
	const { customViewItem } = props;
	const hovering = useHover(ref);

	const {
		isEditingPartial,
		isPersonalView,
		startDeleting,
		startEditingPartial,
	} = customViewItem;

	if (isEditingPartial) {
		return <CustomViewItemEditorPopup customViewItem={customViewItem} />;
	}

	if (!isPersonalView || !hovering) {
		return null;
	}

	return (
		<FlexRowCenter gap={2}>
			<IconButton
				design="iconOnly"
				onClick={startEditingPartial}
				round
				size="small"
			>
				<EditIcon />
			</IconButton>
			<IconButton
				design="iconOnly"
				onClick={startDeleting}
				round
				size="small"
			>
				<CloseIcon />
			</IconButton>
		</FlexRowCenter>
	);
}));

export default CustomViewItemActionMenuPartial;